
import Vue from 'vue';
import Component from 'vue-class-component';
import HeadingWave from "@/features/shared/components/HeadingWave.vue";
import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
import {NotificationModel, NotificationsClient, NotificationState, ResultError} from "@/api-client";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import toasts from "@/components/Toasts";
import bus from "@/EventBus";
import ServersidePaging from "@/components/ServersidePaging";
import FilterCheckbox from "@/components/FilterCheckbox.vue";

class Filters {
    showUnread = true;
    showRead = false;
    showArchived = false;

    getSelectedStates(): NotificationState[] {
        const states = [];

        if (this.showUnread)
            states.push(NotificationState.Unread);

        if (this.showRead)
            states.push(NotificationState.Read);

        if (this.showArchived)
            states.push(NotificationState.Archived);

        return states;
    }
}

@Component({
    components: {
        HeadingWave,
        SectionPageHeading,
        LoadingSpinner,
        FilterCheckbox
    },
})
export default class Notifications extends Vue {
    notifications: NotificationModel[] = [];
    selectedNotificationIds: string[] = [];
    
    filters = new Filters();
    paging = new ServersidePaging();
    
    created() {
        bus.subscribe("notification-update-triggered", () => this.getNotifications(), this);
        
        this.$watch(() => this.filters, () => {
            this.paging.pageNumber = 1;
            this.getNotifications();
        }, { deep: true, immediate: true });

        this.$watch(() => this.paging.pageNumber, () => {
            this.getNotifications();
        });
        this.$watch(() => this.paging.pageSize, () => {
            this.getNotifications();
        });
    }
    
    async getNotifications() {
        const queryResult = await new NotificationsClient().get(this.paging.pageNumber, this.paging.pageSize, this.filters.getSelectedStates());
        this.notifications = queryResult.pageResult;
        this.paging.totalCount = queryResult.totalCount;
        this.paging.pageSize = queryResult.pageSize;
    }
    
    toggleNotificationSelected(isSelected: boolean, notificationId: string) {
        if (isSelected)
            this.selectedNotificationIds.push(notificationId);
        else
            this.selectedNotificationIds.splice(this.selectedNotificationIds.indexOf(notificationId), 1);
    }
    
    clearSelectedNotifications() {
        this.selectedNotificationIds = [];
    }
    
    async markSelectedNotificationsRead() {
        await new NotificationsClient().markRead(this.selectedNotificationIds).then(
            success => {
                this.clearSelectedNotifications();
                this.paging.pageNumber = 1;
                bus.publish("notification-update-triggered");
            },
            (error: ResultError) => error.messagesFlattened.forEach(x => toasts.failure(x))
        );
    }
}
